import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { chooseAmongstUnAggHourlyAndDaily } from '../../../chooseAmongstUnAggHourlyAndDaily'

export const getIrrigationFlowMeterArgs = ({
  selectedValueGroups,
  selectedFieldAssets,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  selectedFieldAssets: TSelectedFieldAssetsStoreState
}): Partial<routes.Values.Request> => {
  if (!selectedValueGroups.irrigation_activity_pressure || !selectedFieldAssets.property) return {}

  const preferredAggregationInterval = {
    preferredAggregationInterval: chooseAmongstUnAggHourlyAndDaily(),
  }

  const property = fieldAssetStore.getState().properties?.[selectedFieldAssets.property]
  const selectedPumpDevice = selectedFieldAssetsStore.getState().flowMeterDevice

  if (!property || !selectedPumpDevice) return {}

  const valuesRequested: Record<string, typeof preferredAggregationInterval> = {
    irrigationFlowRate: preferredAggregationInterval,
  }

  return {
    points: {
      lngLats: [selectedPumpDevice],
      valuesRequested,
    },
  }
}
